module.exports = __webpack_public_path__ + "media/music/piano_chords_5-c386be27.mp3";